<script>
import objectDiff from 'objectdiff';

export default {
  name: 'AuditSublogDiff',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: true,
    },
    hasError: {
      type: Boolean,
      required: true,
      default: false,
    },
    payloadRed: {
      type: String,
      required: true,
    },
    payloadGreen: {
      type: String,
      required: true,
    },
  },
  computed: {
    diffPayloads() {
      if (this.isLoading || this.error) {
        return '';
      }

      const parsedGreen = JSON.parse(this.payloadGreen);
      const parsedRed = JSON.parse(this.payloadRed);

      return objectDiff.convertToXMLString(
        objectDiff.diffOwnProperties(
          (parsedGreen?.payload ?? parsedGreen),
          (parsedRed?.payload ?? parsedRed),
        ),
      );
    },
  },
};
</script>

<template>
  <b-modal
    id="sublog-diff-modal"
    ref="sublog-diff-modal"
    title="Reponse differences"
    size="xl"
    hide-footer
    :visible="isVisible"
    @hidden="$emit('hidden')"
  >
    <b-row>
      <b-col>
        <div
          v-if="hasError"
          class="text-center text-danger"
        >
          <strong>There was an error while trying to fetch response differences</strong>
        </div>

        <div
          v-else-if="!hasError && isLoading"
          class="text-center text-secondary"
        >
          <b-spinner class="align-middle mr-2" />
          <strong>Loading...</strong>
        </div>

        <b-card v-else>
          <!-- eslint-disable-next-line vue/no-v-html vue/max-attributes-per-line -->
          <pre class="diff-viewer" v-html="diffPayloads" />
        </b-card>
      </b-col>
    </b-row>
  </b-modal>
</template>

<style lang="scss">
  .diff-viewer {
    .diff {
      display: inline-block;
    }

    .diff-level {
      margin-left: 1.6em;
    }

    .diff-holder {
      color: #666;
      margin: 0;
    }

    .diff-holder span {
      color: #AAA;
    }

    del.diff,
    ins.diff {
      text-decoration: none;
    }

    del.diff {
      color: #b30000;
      background: #fadad7;
    }

    ins.diff {
      background: #eaf2c2;
      color: #406619;
    }

    del.diff-key {
      border: 1px solid #f8a4a4;
    }

    ins.diff-key {
      border: 1px solid #a3ce4c;
      margin-top: -1px;
      position: relative;
    }

    ins.diff span {
      color: #AABF40;
    }

    del.diff span {
      color: #EE8177;
    }

    height: 100%;
    width: 100%;
    margin: auto;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all !important;
  }
</style>
